function isParentRow(cell) {
    const row = cell.getRow();
    const rowData = row.getData();
    return rowData.parentTask === null;
}

export default {
    isParentRow
}